<template>
  <v-card>
    <JSONDialog ref="dialog" @openMiniParser="openMiniParser" />

    <v-toolbar class="card-bar">
      <v-toolbar-title>Logs</v-toolbar-title>

      <!-- <v-btn-toggle
        class="ml-12"
        v-model="outputType"
        tile
        color="deep-purple accent-3"
        group
      >
        <v-btn value="slices">
          Frames
        </v-btn>

        <v-btn value="operations">
          Operations
        </v-btn>
      </v-btn-toggle> -->

      <v-spacer />
    </v-toolbar>
    <v-card-text>
      <ORow
        fill-x
        top
        v-for="(line, i) in allLines"
        :key="i"
        class="clickable hoverable"
        @click.native="showRowDetails(line)"
      >
        <div class="log-ts">
          {{ line.timestamp | moment('YYYY-MM-DD HH:mm:ss') }}
          ─
          {{ line.typeStr }} {{ line.subTypeStr }}
        </div>
        <pre class="log-line">{{
          line.log || line.verboseLog || line.message
        }}</pre>
      </ORow>
    </v-card-text>
  </v-card>
</template>

<script>
import InspectorStore from './InspectorStore'
import JSONDialog from './JSONDialog.vue'
import brush from 'brush'

export default {
  components: { JSONDialog },
  computed: {
    allLines() {
      return InspectorStore.allLogLines
    }
  },
  methods: {
    showRowDetails(row) {
      this.$refs.dialog.open(row)
    },

    openMiniParser({ frame }) {
      const bytes = InspectorStore.getFrameBytes(frame)
      const hexInput = brush.toHex(bytes, {
        prettyPrint: true,
        bytesPerLine: 32,
        groupSep: '',
        byteSep: ''
      })
      this.$emit('openMiniParser', { hexInput })
    }
  }
}
</script>

<style lang="sass">
.log-ts
  width: 400px
  flex-grow: 0
  flex-shrink: 0

.log-line
  flex-grow: 1
  font-family: monospace
  font-size: 14px
  white-space: pre-wrap
</style>
